import formatDate from './formatDate';

const JobDate = ({date}) => {
    return date && typeof date.toDate === 'function' ? formatDate(date.toDate()) : 'ingen dato satt';
}

export default JobDate;